import { distinctUntilChanged, filter, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { taskListActions } from './task-list-actions'
import { apiRequests } from '../../../http/config'
import { diffAndPrepare, getId } from '../../../utils/entity-utils'
import { toastFailedResponse } from '../../../components/controls/Toaster/Toaster'
import { combineEpics, Epic } from 'redux-observable'
import { RootActions, RootEpic } from '../../root'
import { DepartmentWithUsers } from '../../../responses/departments'
import { tasksSelector } from '../../../utils/selectors'
import { TaskStatus } from '../../../constants/enums'
import { shallowEqual } from 'react-redux'
import { timer } from 'rxjs'

const departments: Epic<RootActions> = action$ => action$.pipe(
    filter(isActionOf(taskListActions.departments.request)),
    switchMap(action => timer(0, 1000 * 60 * 10).pipe(
        takeUntil(action$.pipe(
            filter(isActionOf(taskListActions.departments.cancel)))
        ),
        mergeMap(() => apiRequests.dictionary.list({
            params: {key: 'department'},
            query: {with_users: true, use_permissions: true, has_tasks: true, ...action.payload},
        })),
    )),
    map(({response}) => response.success ?
        taskListActions.departments.success(response.rows as unknown as DepartmentWithUsers[]) :
        taskListActions.departments.failure(toastFailedResponse(response, 'Не удалось получить список отделов'))
    ),
)
const open: RootEpic = action$ => action$.pipe(
    filter(isActionOf(taskListActions.open.request)),
    mergeMap(({payload}) => apiRequests.task.update({
        data: diffAndPrepare(payload.task, payload.changes),
        params: {taskId: payload.task.id}
    })),
    map(({response}) => response.success ?
        taskListActions.open.success(response.row) :
        taskListActions.open.failure(toastFailedResponse(response, 'Не удалось открыть задачу'))
    ),
)

const requestedUpdate: RootEpic = (action$, state$) => state$.pipe(
    map(state => tasksSelector(state.pages.taskList.tasks)(state)),
    map(tasks => tasks.filter(task => task.status_id === TaskStatus.REQUESTED).map(getId)),
    distinctUntilChanged(shallowEqual),
    map(taskListActions.setTasks),
)


export const taskEpic = combineEpics(departments, open, requestedUpdate)